var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Services")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Client Services List"
    },
    on: {
      "click": _vm.showService
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Short/Display Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('companyName')
    },
    attrs: {
      "options": _vm.CompanyShortList,
      "isDisabled": true,
      "selected-option": _vm.selectedcompanyName,
      "name": "companyName",
      "placeholder": "Select Company Name"
    },
    on: {
      "select": _vm.selectCompanyName
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('companyName')),
      expression: "errors.has('companyName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select company name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contract ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text-o' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('contractId')
    },
    attrs: {
      "options": _vm.contractIdList,
      "isDisabled": true,
      "selected-option": _vm.selectedContractId,
      "name": "contractId",
      "placeholder": "Select Contract ID"
    },
    on: {
      "select": _vm.selectContractId
    },
    model: {
      value: (_vm.contractId),
      callback: function($$v) {
        _vm.contractId = $$v
      },
      expression: "contractId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contractId')),
      expression: "errors.has('contractId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select contract id.")])], 1)]), _vm._v(" "), (_vm.showContractTemplate == true) ? _c('div', [_c('Services', {
    ref: "clientServices",
    attrs: {
      "selectedEdit": _vm.selectedEditRow,
      "callingFromClientContract": _vm.callingToContractObj
    },
    on: {
      "goBackToCreateContract": _vm.UpdateClientService
    }
  })], 1) : _vm._e()], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657ff3c7","hasScoped":true}!./src/modules/clientmanagement/views/ClientServices/CreateClientServices/CreateClientServices.component.html
// module id = 735
// module chunks = 3